/**
 * 数字趋势图卡片
 */
import React, {useRef} from 'react';
import {Bubble} from "tea-component";
import {useIntl} from "umi";
import SvgIcon from "@home/components/SvgIcon";
import {formatPercentNum} from "@/pages/datalab/utils/utils";
import {useTrendChartOptions} from "@customComp/Chart/_config/_hooks";
import Chart from "@customComp/Chart";
import BubbleEllipsis from "@/pages/datalab/components/BubbleEllipsis";
import classNames from "classnames";

import './index.scss';

// 环比, 同期, 变化率 数据展示
function MetricChange(props: any) {
  const { name, value} = props;
  const showText = formatPercentNum(value, 1, true);
  const status = ['-', '0%'].includes(showText) ? 'default' : (Number(value) > 0 ? 'up' : 'down');
  
  return (<div className={'dbl-change'}>
    <div className={'dbl-change-name'}>{name}</div>
    <div className={`dbl-change-value ${status}`}>
      {showText}
      { status !== "default" ? <SvgIcon className='' type={status === 'up' ? 'green-up-new' : 'red-down-new'} /> : ''}
    </div>
  </div>);
}

// 涨跌浮窗
const UpsAndDownsBubbleContent = (props: any) => {
  const {formatMessage} = useIntl();
  return props.data?.map(info => {
    const {titleId, thisTime, lastTime, thisValue, lastValue} = info || {};
    return (
      <div key={titleId} className='bubble-item'>
        <div className='bubble-title'>{formatMessage({id: titleId})}</div>
        <div className='bubble-flex'>
          <div className='bubble-text'>
            <div className='bubble-t'>{thisTime || '-'}</div>
            <div className='bubble-b'>{lastTime || '-'}</div>
          </div>
          <div className='bubble-ct'>VS</div>
          <div className='bubble-text'>
            <div className='bubble-t'>{thisValue || '-'}</div>
            <div className='bubble-b'>{lastValue || '-'}</div>
          </div>
        </div>
      </div>
    );
  });
};

function MetricInfo(props: any) {
  const {metricValue, dod, sdlw, change, granularity, changeBubbleData} = props;
  const {formatMessage} = useIntl();
  
  return (<div className={`dbl-metric-info${change ? ' change' : ''}`}>
    
    {/* 指标值展示 */}
    <BubbleEllipsis
      content={metricValue}
      ellipsisClassName={'dbl-metric-info-big-value'}
    />
    
    
    <Bubble
      trigger="hover"
      dark
      className={'dbl-trend-bubble'}
      // placement="bottom-start"
      // 用户控制 环比, 同期, 变化率都不显示的时候, 没有浮窗显示
      content={changeBubbleData?.length > 0 ? (<UpsAndDownsBubbleContent data={changeBubbleData}/>) : undefined}
      escapeWithReference={true}
      // popupContainer={document.querySelector('.dbl-dashboard-body-background')}
    >
      <div className={'dbl-change-wrap'}>
        
        {/* 环比展示*/}
        {
          dod === false ? '' : <MetricChange name={formatMessage({id: `dbl_common_dod_${granularity}`})} value={dod}/>
        }
        
        {/* 同期展示 */}
        {
          sdlw === false ? '' : <MetricChange name={formatMessage({id: `dbl_common_sdlw_${granularity}`})} value={sdlw}/>
        }
        
        {/* 变化率展示*/}
        {
          change === false ? '' : <MetricChange name={formatMessage({id: 'dbl_common_change'})} value={change}/>
        }
      
      </div>
    </Bubble>
  </div>);
}

export default function NumberTrendChart(props: any) {
  const {metricName, granularity, metricValue, dod, sdlw, change, trendChartData=[], metricNameKey, className='', changeBubbleData,  trendStatus, staticTime, formatValue} = props;
  const {showTrend, showChange, showSdlw, showDod, showStaticTime} = trendStatus ||{};
  
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const chartRef = props.chartRef || useRef();
  
  const trendOptions = useTrendChartOptions(trendChartData, metricNameKey, granularity, formatValue);
  return (
    <div className={classNames('dbl-trend-chart-body', className)}>
      <div className={'dbl-trend-chart-left'}>
        {metricName ? (<div className={'dbl-trend-chart-metric-name'}>
          <SvgIcon type={'plate'}/>{metricName}
        </div>) : ''
        }
        {showStaticTime && staticTime ? (<div className={'dbl-trend-chart-static-time'}>{staticTime}</div>) : ''}
        <MetricInfo
          metricValue={metricValue}
          dod={showDod && dod} // 展示 环比, 赋值dod数据
          sdlw={showSdlw && sdlw}
          change={showChange && change}
          granularity={granularity}
          changeBubbleData={changeBubbleData}
        />
      </div>
      {
        (showTrend && trendChartData) === false ? '' : (<div className={`dbl-trend-chart-right`}>
          <Chart ref={chartRef} option={trendOptions} notMerge={true} />
        </div>)
      }
  
    </div>
  );
  
}